import { App } from '@capacitor/app';
import router from '@/core/router';
import { refreshAnalyticsSession } from '@/core/analytics/analytics';
import { AppSessionSourceNames } from '@/core/analytics/types';
import { useShareLinkDetector } from '@/shared/composables/useShareLinkDetector';
import { useInviteStore } from '@/modules/invite/stores/invite';

let lastProcessedUrl: string | null = null;
let lastProcessedTime = 0;

/**
 * Unified handler for opening the app via URL (DeepLink)
 * Centralizes analytics session refresh, share link data saving, and routing.
 */
export const handleAppOpenUrl = (url: string) => {
  if (!url) {
    return;
  }

  const now = Date.now();
  if (url === lastProcessedUrl && now - lastProcessedTime < 2000) {
    return;
  }
  lastProcessedUrl = url;
  lastProcessedTime = now;

  refreshAnalyticsSession(AppSessionSourceNames.DeepLink, url);

  const { shareLinkOpenedSaveData } = useShareLinkDetector();
  shareLinkOpenedSaveData(url);

  const inviteStore = useInviteStore();
  inviteStore.persistInviteFromUrl(url);

  try {
    const urlObj = new URL(url);
    const path = urlObj.pathname;
    const hash = urlObj.hash;
    const query: Record<string, string> = {
    };

    urlObj.searchParams.forEach((value, key) => {
      query[key] = value;
    });

    if (path) {
      router.push({
        path,
        query,
        hash,
      });
    }
  } catch (error) {
    console.error('DeepLinksPlugin: Failed to parse URL', url, error);
  }
};

export const DeepLinksPlugin = {
  install() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    App.addListener('appUrlOpen', (data: any) => {
      handleAppOpenUrl(data.url);
    });
  },
};
